<div mat-dialog-title><mat-icon class="schedule-icon" svgIcon="schedule"></mat-icon><span translate>need4steel-order.history.title</span> </div>
<button type="button" mat-icon-button class="delete-icon" [mat-dialog-close]="true"><mat-icon class="close-icon" svgIcon="md:close"></mat-icon>
</button>
<mat-dialog-content>
	<div *ngIf="showNoOrderMessage" class="error-alert-box  card-block">
		<div class="copo-notification-block copo-notification-message-line">
			<mat-icon svgIcon="alert" class="copo-notification-icon"></mat-icon>
			<div class="error-message">
				<div class="error-alert-title" translate>need4steel-order.history.notfound</div>
				<div class="error-alert-description" translate>need4steel-order.history.errormsg</div>
			</div>
		</div>
	</div>
	<div *ngIf="!showNoOrderMessage">
		<div>
			<span translate>need4steel-order.history.subtitle</span>
		</div>
		<ag-grid-angular class="ag-theme-balham order-history-ag-grid" [gridOptions]="gridOptions" [modules]="modules"
			(gridReady)="onGridReady($event)" (viewportChanged)="onViewportChanged($event)">
		</ag-grid-angular>
	</div>
	<div class="button-wrapper">
		<button *ngIf="!showNoOrderMessage" type="button" (click)="importHistory()" color="primary" mat-flat-button class="button-style">
			<span translate>need4steel-order.history.import</span>
		</button>
	</div>
</mat-dialog-content>